module.exports = __webpack_public_path__ + "assets/img/verify-backup-code.d49f5f62.png";